import { baseApi } from "./baseApi";

export type EventDispatchSinkId =
  | "user_notify"
  | "channel_announcement"
  | "email"
  | "tg_logger"
  | "broadcast"
  | "agent"
  | "twitter";

export const EVENT_DISPATCH_SINK_OPTIONS: { id: EventDispatchSinkId; label: string; hint: string }[] = [
  { id: "user_notify", label: "User notify", hint: "Telegram DM + web push via messenger" },
  { id: "channel_announcement", label: "TG channel", hint: "Public announcement channel (articles / announcements)" },
  { id: "email", label: "Email", hint: "Messenger template; needs recipient / template config" },
  { id: "tg_logger", label: "TG logger", hint: "Admin logger channel" },
  { id: "broadcast", label: "Broadcast", hint: "All users — requires safe metadata on emitted events" },
  { id: "agent", label: "Pi agent", hint: "External ingest" },
  { id: "twitter", label: "Twitter", hint: "Not wired yet" },
];

export interface EventDispatchAdminPayload {
  eventTypes: string[];
  effective: Record<string, EventDispatchSinkId[]>;
  codeDefaults: Partial<Record<string, EventDispatchSinkId[]>>;
  updatedAt: string | null;
  updatedByUsername: string | null;
}

export interface EventDispatchGetResponse {
  success: boolean;
  data: EventDispatchAdminPayload;
}

export interface EventDispatchPutResponse {
  success: boolean;
  data: EventDispatchAdminPayload;
}

export const eventDispatchAdminApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEventDispatchConfig: builder.query<EventDispatchGetResponse, void>({
      query: () => "/v2/admin/event-dispatch",
      providesTags: ["EventDispatch"],
    }),
    putEventDispatchConfig: builder.mutation<
      EventDispatchPutResponse,
      { rules: Record<string, EventDispatchSinkId[]> }
    >({
      query: (body) => ({
        url: "/v2/admin/event-dispatch",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["EventDispatch"],
    }),
  }),
  overrideExisting: false,
});

export const { useGetEventDispatchConfigQuery, usePutEventDispatchConfigMutation } =
  eventDispatchAdminApi;
